import { defineComponent as _defineComponent } from 'vue';
import icons from '@common/icons';
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseErrorMessage',
  props: {
    errors: null
  },
  setup(__props) {
    return {
      __sfc: true,
      icons
    };
  }
});